module.exports = __webpack_public_path__ + "static/media/ck_underwear.5cf9246a.jpg";